import React from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import { red } from '@material-ui/core/colors';
import withStyles from "@material-ui/core/styles/withStyles";
import * as PropTypes from "prop-types";
import {AddCircleOutlineTwoTone} from "@material-ui/icons";
import Modal from "@material-ui/core/Modal";
import moment from "moment";
import {BlueButton} from "../common/ButtonsConstants";
import CommonRevisionModal from "../common/CommonRevisionModal";
import * as CommonUtils from "../../util/CommonUtils";
import ApprovedSupplierListRevisionModal from "./ApprovedSupplierListRevisionModal";
import { t } from '../../i18n';

const classes = () => ({
    card: {
        width: '100%',
    },
    avatar: {
        backgroundColor: red[500],
        fontSize: 10,
    },
});

class DocumentControlHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            revision: this.props.revision,
        };
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    addRevision(request) {

    }

    showModal() {
        this.setState({
            show: true
        });
    }

    closeModal(updatedRevision) {
        if (updatedRevision) {
            this.setState({
                show: false,
                revision: updatedRevision,
            });
        } else {
            this.setState({
                show: false,
            });
        }
    }

    render() {
        const { classes } = this.props;
        const { show, revision } = this.state;

        const isRevision = revision.completedBy && revision.completedOn;
        return <div>
            <Card className={classes.card}>
                <CardHeader
                    action={
                        <BlueButton
                            variant="contained"
                            color="secondary"
                            startIcon={<AddCircleOutlineTwoTone/>}
                            onClick={this.showModal}
                            size="small"
                            style={{marginRight: '10px'}}
                            disabled={this.props.isReadOnly}
                        >
                            { t('common.add') }
                        </BlueButton>
                    }
                    title={
                        <span style={{color: "darkblue"}}>
                            <p><b>{isRevision ? (<span>{t('context.common.revision')} {revision.number}: {moment(revision.date).format('DD/MM/YYYY')}</span>) : <span>{ t('operation.approvedSupplierList.title') }</span>}</b></p>
                        </span>
                    }
                    subheader={
                        isRevision &&
                        <span>
                            <p>{ t('operation.approvedSupplierList.assessmentCompletedBy') }: {revision.completedBy}</p>
                            <p>{ t('operation.approvedSupplierList.date') }: {moment(revision.completedOn).format('DD/MM/YYYY')}</p>
                        </span>
                    }
                />
                <CardContent>
                    {this.props.children}
                </CardContent>
            </Card>
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={show}
                onClose={() => this.closeModal(null)}
            >
                <ApprovedSupplierListRevisionModal latestRevisionDto={revision} addRevision={this.addRevision} postSubmit={this.closeModal}/>
            </Modal>
        </div>
    }
}

DocumentControlHeader.propTypes = {
    revision: PropTypes.object.isRequired,
};

export default withStyles(classes)(DocumentControlHeader);